import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import FormDropdown from '../../components/form/FormDropdown/FormDropdown';

const FormDropdownContainer = props =>
  <Field
    name={props.name}
    component={FormDropdown}
    props={props}
  />
;

FormDropdownContainer.propTypes = {
  name: PropTypes.string
};

export default (FormDropdownContainer);



/** WEBPACK FOOTER **
 ** ./src/redux/containers/FormDropdownContainer.js
 **/